import React, { Component } from 'react'
import { MuiIconButton, MuiGrid, MuiClear, MuiTextField, MuiEdit, MuiTypography } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import lodashUtil from 'lodash';
import { gradePickerUtil } from '../../gradePicker';
import { GradePickerComponent } from '../../gradePicker';
import { toast } from 'react-toastify';
import AlertDialogComponent from './AlertDialogComponent';
import { rulesUtil } from '../rules/dialog';

export class AssigningSubjectComponent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			toggleChange: false,
			gradeString: undefined,
			gradeLevelToBeShown: JSON.parse(JSON.stringify(this.props.gradeLevelsToBeRendered)),
			saveFlag: false,
			subSetGradeDetails: undefined,
			subjectCode: "",
			gradeDetailForAssignedSubject: this.props.assignedSubject.gradeDetails,
			showConfirmDialogForDeletingSuject: false,
			constraintsArray: [
				"fixedTeachersAndTAsForElectives",
				"fixedTeachersAndTAsForSubjects"
			],
			prevAssigedSubject: JSON.parse(JSON.stringify(this.props.assignedSubject)),
			showConfirmDialogForChangeOfRole: false,
			validationFlag: false,
			showConfirmDailogForSubectName: false,
			showGradeDetailChangeConfirmDialog: false,
			name: "",
			value: "",
			gradeDetails: {}
		}
	}

	validationForAssignedSubjectIfChanged = (name, value) => {
		this.state.name = name
		this.state.value = value
		if (this.props.assignedSubject._id !== undefined) {
			let changeSubjectNameInRules = "showConfirmDialogForDeletingSuject"
			if (name === "subjectName" && value !== this.state.prevAssigedSubject.subjectName) {
				this.props.updateData()
				if (this.props.deleteAssignedSubjectFromRules(this.props.assignedSubject, this.props.teacher, changeSubjectNameInRules)) {
					this.setState({
						showConfirmDialogForChangeOfRole: true,
					})
					return
				}
			}
			else if (name === "isMainTeacher" && value !== this.state.prevAssigedSubject.isMainTeacher) {
				if (this.props.deleteAssignedSubjectFromRules(this.props.assignedSubject, this.props.teacher, changeSubjectNameInRules)) {
					this.setState({
						showConfirmDialogForChangeOfRole: true,
					})
					return
				}
			}
		}
		this.onChange(name, value)
	}
	handleDeleteRulesIfRoleIsChanged = () => {
		this.props.deleteAssignedSubjectFromRules(this.props.assignedSubject, this.props.teacher, "deleteRule")
		this.onChange(this.state.name, this.state.value)
		this.setState({
			showConfirmDailogForSubectName: false,
			showConfirmDialogForChangeOfRole: false,
		})
	}
	onChange = async (name, value) => {
		if (name === "subjectName") {
			this.props.assignedSubject[name] = value
			let subjectsArray = this.props.activeSchool.school_master.subjects
			let subjectObj = lodashUtil.find(subjectsArray, ["name", value]);
			let gradeString;
			if (subjectObj !== undefined) {
				this.props.assignedSubject.subjectId = subjectObj._id
				this.props.assignedSubject.subjectCode = subjectObj.code;
				gradeString = gradePickerUtil.getGradesString(subjectObj.gradeDetails);
				this.props.assignedSubject.gradeDetails = subjectObj.gradeDetails;
			}
			let gradeLevelToBeShown = gradePickerUtil.showSubsetOfGrades(this.props.gradeLevelsToBeRendered, subjectObj.gradeDetails);
			this.props.assignedSubject.gradeDetails = subjectObj.gradeDetails;
			this.setState({ toggleChange: !this.state.toggleChange, gradeString: gradeString, gradeLevelToBeShown, subjectCode: subjectObj.code });
		} else {
			this.props.assignedSubject[name] = value
			this.setState({ toggleChange: !this.state.toggleChange })
		}
		this.props.updateData()
	}

	handleCheckIfSubjectExistInRule = () => {
		let assignedSubjects = this.props.assignedSubject
		if (this.props.deleteAssignedSubjectFromRules(assignedSubjects, this.props.teacher, "showConfirmDialogForDeletingSuject")) {
			this.setState({
				showConfirmDialogForDeletingSuject: true
			})
		} else {
			this.props.removeAssignedSubjectFromTeacher(this.props.index)
		}
	}
	handleDelete = () => {
		this.props.updateData()
		this.props.removeAssignedSubjectFromTeacher(this.props.index)
		this.setState({
			showConfirmDialogForDeletingSuject: false
		})
	}
	handleCloseDialog = () => {
		this.setState({
			showGradeDetailChangeConfirmDialog: false,
			showConfirmDialogForDeletingSuject: false,
			showConfirmDialogForChangeOfRole: false
		})
	}
	handleOpen = () => {
		const i18n = this.props.i18n
		if (this.props.assignedSubject.subjectName !== null) {
			let subjectGradeDetailsInProps = this.props.assignedSubject.gradeDetails;
			let subjectArray = this.props.activeSchool.school_master.subjects;
			let subjectName = this.props.assignedSubject.subjectName
			let isSubjectPresent = lodashUtil.find(subjectArray, ["name", subjectName]);
			let subjectGD = isSubjectPresent.gradeDetails
			// get the subset and construct the required object and then save it to state and send it to the grade picker
			let subSetGradeLevel = gradePickerUtil.showSubsetOfGrades(this.props.gradeLevelsToBeRendered, subjectGD);
			let savedGradeLevel = gradePickerUtil.constructGradeLevelJSON(subSetGradeLevel, subjectGradeDetailsInProps)
			this.setState({
				open: true,
				gradeLevelToBeShown: savedGradeLevel
			});
		} else {
			toast(i18n.teachers.selectSubject);
		}
	};

	handleClose = () => {
		this.setState({ open: false })
	};
	onClickOfYesForGradePicker = () => {
		this.props.deleteAssignedSubjectFromRules(this.props.assignedSubject, this.props.teacher, "deleteRule")
		this.onClickOfSaveInGradePicker(this.state.gradeDetails)
		this.setState({
			showGradeDetailChangeConfirmDialog: false,

		})
		this.props.updateData()

	}
	checkIfGradeDetailsAreChanged = (gradeDetails) => {
		if (this.props.assignedSubject._id !== undefined) {
			this.props.updateData()
			if (this.props.deleteAssignedSubjectFromRules(this.props.assignedSubject, this.props.teacher, "showConfirmDialogForDeletingSuject")) {
				if (rulesUtil.checkIfGradeDetailsAreChanged(this.state.constraintsArray, gradeDetails, "showConfirmDialogForDeletingSuject", this.props.assignedSubject, this.props.schedule_constraints, this.props)) {

					this.setState({
						showGradeDetailChangeConfirmDialog: true,
						gradeDetails: gradeDetails
					})
					return
				}
			}
		}
		this.onClickOfSaveInGradePicker(gradeDetails)
	}
	onClickOfSaveInGradePicker = (gradeDetails) => {
		let gradeString = gradePickerUtil.getGradesString(gradeDetails)
		this.props.assignedSubject.gradeDetails = gradeDetails;
		this.props.updateData()
		this.setState({
			open: false,
			gradeString: gradeString,
			saveFlag: true,
		})
	}
	componentWillMount() {
		if (this.props.assignedSubject !== undefined) {
			let gradeDetails = this.props.assignedSubject.gradeDetails
			let gradeString = gradePickerUtil.getGradesString(gradeDetails)
			this.setState({
				gradeString: gradeString
			})
		}
	}
	render() {
		const { i18n } = this.props
		return (
			<div>
				<GradePickerComponent
					gradeLevels={this.state.gradeLevelToBeShown}
					{...this.state}
					{...this.props}
					handleClose={this.handleClose}
					handleOpen={this.handleOpen}
					onClickOfSaveInGradePicker={this.checkIfGradeDetailsAreChanged}
				/>
				<MuiGrid container xs={12}>
					<MuiGrid item xs={2} style={theme.gridTableSelectStyle}>
						<MuiTextField
							select
							id="subjectName"
							value={this.props.assignedSubject.subjectName}
							style={{ width: "100%", height: "100%" }}
							onChange={(event) => this.validationForAssignedSubjectIfChanged('subjectName', event.target.value)}
							SelectProps={{ native: true, disableUnderline: true }}>
							<option style={{ display: 'none' }}></option>
							{lodashUtil.sortBy(this.props.activeSchool.school_master.subjects, '[name]', 'asc').map((subject) => <option
								value={subject.name}>{subject.name}</option>)}
						</MuiTextField>
					</MuiGrid>

					{/* subject code  */}
					<MuiGrid item container xs={2} justify="center" alignItems="center" style={theme.gridTableStyle}>
						<MuiTypography>{this.props.assignedSubject.subjectCode}</MuiTypography>
					</MuiGrid>

					<MuiGrid item xs={2} style={theme.gridTableSelectStyle}>
						<MuiTextField
							//	variant="outlined"
							id="teacher"
							select
							value={this.props.assignedSubject.isMainTeacher}
							style={{ width: "100%", height: "100%" }}
							onChange={(event) => this.validationForAssignedSubjectIfChanged('isMainTeacher', event.target.value)}
							SelectProps={{ native: true, disableUnderline: true }}>
							<option
								value='true'>{i18n.teachers.mainTeacherRole}</option>
							<option
								value='false'>{i18n.teachers.taRole}</option>
						</MuiTextField>
					</MuiGrid>

					<MuiGrid item xs={2} style={theme.gridTableSelectStyle}>
						<MuiTextField
							//	variant="outlined"
							id="teacher"
							select
							value={this.props.assignedSubject.isFixedTeacher}
							style={{ width: "100%", height: "100%" }}
							onChange={(event) => this.validationForAssignedSubjectIfChanged('isFixedTeacher', event.target.value)}
							SelectProps={{ native: true, disableUnderline: true }}>
							<option
								value='true'>{i18n.teachers.preferredDropDownValue}</option>
							<option
								value='false'>{i18n.teachers.normalDropDownValue}</option>
						</MuiTextField>
					</MuiGrid>

					<MuiGrid item xs container justify="center" alignItems="center" style={theme.gridTableBeforeEditStyle}>
						<MuiTypography >
							{this.state.gradeString}
						</MuiTypography>
					</MuiGrid>

					< MuiGrid item style={theme.gridTableEditStyle} justify="center" align="center">
						<MuiIconButton id="open" onClick={() => this.handleOpen()} >
							< MuiEdit style={{ color: theme.palette.grey.dark }}>
							</MuiEdit>
						</MuiIconButton>
					</MuiGrid>

					< MuiGrid item style={theme.gridTableClearButtonStyle} justify="center " alignContent="center">
						<MuiIconButton id="delete" onClick={() => this.handleCheckIfSubjectExistInRule()}>
							<MuiClear style={{ color: theme.palette.grey.dark }} />
						</MuiIconButton>
						{this.state.showConfirmDialogForDeletingSuject &&
							<AlertDialogComponent
								{...this.props}
								errorMessage={i18n.teachers.relatedInfoDeletingMsgForDeletingSubjectInTeachingSkills}
								openDialog={this.state.showConfirmDialogForDeletingSuject}
								handleCloseDialog={this.handleCloseDialog}
								handleClickOnYes={this.handleDelete}
							/>
						}
						{this.state.showConfirmDialogForChangeOfRole &&
							<AlertDialogComponent
								{...this.props}
								errorMessage={i18n.teachers.relatedInfoDeletingMsgForSubjectChangeOrRoleChange}
								openDialog={this.state.showConfirmDialogForChangeOfRole}
								handleCloseDialog={this.handleCloseDialog}
								handleClickOnYes={this.handleDeleteRulesIfRoleIsChanged}
							/>
						}

						{this.state.showGradeDetailChangeConfirmDialog &&
							<AlertDialogComponent
								{...this.props}
								errorMessage={i18n.teachers.relatedInfoDeletingMsg}
								openDialog={this.state.showGradeDetailChangeConfirmDialog}
								handleCloseDialog={this.handleCloseDialog}
								handleClickOnYes={this.onClickOfYesForGradePicker}
							/>
						}
					</ MuiGrid>

				</ MuiGrid></div>

		)
	}
}

export default AssigningSubjectComponent

